import React, { Component } from 'react';
import './CommingSoon.css';
const ComingSoon = () => {
  return <h1>Kem Cho Rahul Bhai!</h1>;
};

export default ComingSoon;
